import { fetchSalesPersonByCreatorReference } from '../../api/salesPeople';
import { fetchOrganizationAdminUserByCreatorReference } from '../../api/users';

const LOCALE = 'es';

export type OrderCreatorDisplayInfo = {
  name: string;
  isAdmin: boolean;
};

/** Title-style words for names; leaves email-shaped strings unchanged. */
export function pascalCaseWords(text: string): string {
  const t = text.trim();
  if (!t || t.includes('@')) return t;
  return t
    .split(/\s+/)
    .map(word => {
      if (!word) return word;
      const lower = word.toLocaleLowerCase(LOCALE);
      return (
        lower.charAt(0).toLocaleUpperCase(LOCALE) + lower.slice(1)
      );
    })
    .join(' ');
}

/**
 * Resolve `order.creatorSalesPerson` for list display: vendedor, then org admin user, then fallback.
 */
export async function resolveOrderCreatorDisplay(
  organizationId: string,
  stored: string
): Promise<OrderCreatorDisplayInfo> {
  const raw = stored.trim();
  try {
    const sp = await fetchSalesPersonByCreatorReference(organizationId, raw);
    if (sp) {
      const base =
        (sp.name || '').trim() ||
        (sp.email || '').trim() ||
        (sp.code || '').trim() ||
        raw;
      return { name: pascalCaseWords(base), isAdmin: false };
    }

    const admin = await fetchOrganizationAdminUserByCreatorReference(
      organizationId,
      raw
    );
    if (admin) {
      const base =
        (admin.displayName || '').trim() ||
        (admin.email || '').trim() ||
        raw;
      return { name: pascalCaseWords(base), isAdmin: true };
    }

    if (/^administrador$/i.test(raw)) {
      return { name: pascalCaseWords(raw), isAdmin: true };
    }

    return { name: pascalCaseWords(raw), isAdmin: false };
  } catch {
    return { name: pascalCaseWords(raw), isAdmin: false };
  }
}
